export default __webpack_public_path__ + "0c7113f2150e44791b12936ad709309b.png";